import { get, post, webApi } from '../utils/http';
import queryString from 'query-string';

export const services = {
  getTags: () =>
    get(webApi + `api/profiles/tags?lang=${localStorage.getItem('language')}`),
  getAllProfiles: () =>
    get(
      webApi +
        `api/profiles?page_size=200&lang=${localStorage.getItem('language')}`,
    ),
  getProfiles: (tags) =>
    get(
      webApi +
        `api/profiles?lang=${localStorage.getItem('language')}&tag_ids=${tags}`,
    ),
  getProfileSkills: () =>
    get(
      webApi +
        `api/skills?page_size=1000&lang=${localStorage.getItem('language')}`,
    ),
  getProfileSkillsRange: (body) => {
    let id_results = body.results.map((item) =>
      item.id_result ? item.id_result : item,
    );
    let id_skills = body.skills;
    let excel = body.excel;
    let bodyData = { id_results, id_skills, excel };
    return post(
      webApi +
        `api/results/reports/skills?lang=${localStorage.getItem('language')}`,
      bodyData,
    );
  },
  getDiscProfiles: (body) => {
    const id_results = body.results.map((item) =>
      item.id_result ? item.id_result : item,
    );
    const payload = { id_results };
    if (Array.isArray(body.skill_ids) && body.skill_ids.length > 0) {
      payload.skill_ids = body.skill_ids;
    }
    return post(
      webApi +
        `api/results/reports/disc?lang=${localStorage.getItem('language')}`,
      payload,
    );
  },
};
